

import VueRouter from "vue-router";
import VueMeta from 'vue-meta';
import VueI18n from 'vue-i18n'
import Environment from "./environment";
import Url from "./url";
import BatixIndustrialUIFramework from "@bx/batix-industrial-ui-framework";
import VueLoading from 'vue-loading-overlay';
import SignaturePad from "vue-signature-pad";
import Vuelidate from 'vuelidate'

import { isMobile, isAndroid, isWinPhone, isIOS } from 'mobile-device-detect';

/**
 * Setup Plugins for the Vue instance
 * @param {VueConstructor<Vue>} instance
 */
export function setupPlugins (instance) {
  instance.use(VueRouter);

  instance.use(BatixIndustrialUIFramework);

  instance.use(VueMeta, { refreshOnceOnNavigation: true });

  instance.use(Url)

  instance.use(VueI18n)

  instance.use(VueLoading);

  instance.use(SignaturePad);

  instance.use(Vuelidate);

  instance.use(Environment, { isMobile: isMobile || isAndroid || isWinPhone || isIOS })
}
